module.exports = __webpack_public_path__ + "b5fb9d874a408e9e8fe09d54c7d56ab7.pdf";